import moment from 'moment';

export default class DailyEvent {
  constructor({
    date,
    methodName,
  }) {
    this.date = date;
    this.methodName = methodName;
  }

  toPOJO() {
    return {
      ...this,
    };
  }

  static fromPOJO(pojo) {
    return new DailyEvent({
      date: moment(pojo.date),
      methodName: pojo.methodName,
    });
  }
}
